import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import "@/App.css";
import SmoothScroll from "@/components/inskin/SmoothScroll";
import Nav from "@/components/inskin/Nav";
import Hero from "@/components/inskin/Hero";
import Marquee from "@/components/inskin/Marquee";
import Philosophy from "@/components/inskin/Philosophy";
import WhoWeAre from "@/components/inskin/WhoWeAre";
import Treatments from "@/components/inskin/Treatments";
import Store from "@/components/inskin/Store";
import Booking from "@/components/inskin/Booking";
import Footer from "@/components/inskin/Footer";
import { PaymentSuccess, PaymentCancel } from "@/components/inskin/Payments";
import { EASE } from "@/components/inskin/motion";

function Loader() {
    const [done, setDone] = useState(false);
    useEffect(() => {
        const t = setTimeout(() => setDone(true), 1200);
        return () => clearTimeout(t);
    }, []);
    return (
        <AnimatePresence>
            {!done && (
                <motion.div
                    data-testid="intro-loader"
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-ink"
                    exit={{ y: "-100%" }}
                    transition={{ duration: 0.9, ease: EASE }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: EASE }}
                        className="text-center"
                    >
                        <span className="font-serif text-5xl font-light italic text-cream">
                            In Skin
                        </span>
                        <span className="mt-4 block font-mono text-[10px] uppercase tracking-[0.35em] text-clay">
                            Clinical skin · Elevated you
                        </span>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <div className="grain bg-cream">
                <SmoothScroll />
                <Loader />
                <Nav />
                <main>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <>
                                    <Hero />
                                    <Marquee />
                                    <Philosophy />
                                    <WhoWeAre />
                                    <Treatments />
                                    <Store />
                                    <Booking />
                                </>
                            }
                        />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </BrowserRouter>
    );
}
